import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_EDITOR_API_URL } from '../../../../constants/ApiUrlConstants';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { checkForceUnclaimRequest, editorFailure, editorSuccess } from '../actions';

const editorAPI = (action) => postApiRequest(PROOFREADER_EDITOR_API_URL, action);

export function forwardTo(location) {
  history.push(location);
}

function* handleEditor(action) {
  try {
    const response = yield call(editorAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if (!response.data?.success) {
      yield call(forwardTo, DASHBOARD_ROUTE);
    }
    const parsedResponse = JSON.parse(response.data.value);
    yield put(
      checkForceUnclaimRequest({
        userId: action.payload.userId,
        claimId: parsedResponse?.ClaimId,
      }),
    );
    yield put(editorSuccess(response));
  } catch (error) {
    yield put(editorFailure(error));
  }
}

export function* watchEditor() {
  yield takeLatest(types.EDITOR_REQUEST, handleEditor);
}
